import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/index.vue'
import Category from '../views/category/index.vue'
import Profile from '../views/profile/index.vue'
import Login from '../views/login/index.vue' //登录
import Detail from '../views/detail/index.vue' //游戏详情
import FirstEpisode from '../views/firstEpisode/index.vue' //首发
import OpenServer from '../views/openServer/index.vue'
import Rank from '../views/rank/index.vue'
import SpecialOffer from '../views/specialOffer/index.vue'
import OneOff from '../views/oneOff/index.vue'
import GameCircle from '../views/gameCircle/index.vue' //游戏圈
import SelectedMaster from '../views/selectedMaster/index.vue' // 精选大作
import InviteFriends from '../views/inviteFriends/index.vue'// 邀请好友
import Recharge from '../views/recharge/index.vue' //充值页面
import SignCard from '../views/signCard/index.vue' //签到月卡
import Balance from '../views/balance/index.vue' //余额明细
import InviteRecord from '../views/inviteRecord/index.vue' //邀请记录
import CollectionRecord from '../views/collectionRecord/index.vue'  // 领取记录
import RechargeRecord from'../views/rechargeRecord/index.vue'
import MsgCenter from'../views/msgCenter/index.vue' // 消息中心
import AboutWM from'../views/aboutWM/index.vue' // 关于万梦
import LeaveMsg from'../views/leaveMsg/index.vue' // 留言
import BalanceRecharge from '../views/balanceRecharge/index.vue'  //余额充值
import Coupon from '../views/coupon/index.vue'  //优惠券
import RechargeSearch from '../views/rechargeSearch/index.vue' //充值游戏搜索页
import HomeSearch from '../views/homeSearch/index.vue' //充值游戏搜索页
import PayResult from '../views/payResult/index.vue' //充值结果页
import YouLike from '../views/youLike/index.vue' //猜你喜欢
import AccountTrade from '../views/accountTrade/index.vue' // 账号交易
import GoodsDetail from '../views/goodsDetail/index.vue' // 商品详情
import CouponUse from '../views/couponUse/index.vue' // 选择优惠券
import Problem from '../views/problem/index.vue' // 常见问题
import PrivacyAgreement from '../views/privacyAgreement/index.vue' //隐私协议
import ServiceAgreement from '../views/serviceAgreement/index.vue' //服务协议
import BaseSetting from '../views/baseSetting/index.vue' //编辑个人信息
import TradingNotice from '../views/tradingNotice/index.vue' //交易须知
import TradeRecord from '../views/tradeRecord/index.vue' //交易记录
import CellAccount from '../views/cellAccount/index.vue' //出售账号
import AccountChose from '../views/accountChose/index.vue' //出售账号
import GamePoints from '../views/gamePoints/index.vue' //转游积分
import MyCollect from '../views/myCollect/index.vue' //我的收藏
import WelfareCollection from '../views/welfareCollection/index.vue' //领取福利
import WelfareDetail from '../views/welfareDetail/index.vue' //领取福利
import AllGame from '../views/allGame/index.vue' //领取福利




Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'homePage',
    component: Home,
    meta: { showTabs: true }
  },
  {
    path: '/home',
    name: 'homePage',
    component: Home,
    meta: { showTabs: true }
  },
  {
    path: '/category',
    name: 'categoryPage',
    component: Category,
    meta: { showTabs: true }
  },
  {
    path: '/profile',
    name: 'profilePage',
    component: Profile,
    meta: { showTabs: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { showTabs: false }
  },
  {
    path: '/detail',
    name: 'Detail',
    component: Detail,
    meta: { showTabs: false }
  },
  {
    path: '/firstEpisode',
    name: 'FirstEpisode',
    component: FirstEpisode,
    meta: { showTabs: false }
  },
  {
    path: '/openServer',
    name: 'OpenServer',
    component: OpenServer,
    meta: { showTabs: false }
  },
  {
    path: '/rank',
    name: 'Rank',
    component: Rank,
    meta: { showTabs: false }
  },
  {
    path: '/specialOffer',
    name: 'SpecialOffer',
    component: SpecialOffer,
    meta: { showTabs: false }
  },
  {
    path: '/oneOff',
    name: 'OneOff',
    component: OneOff,
    meta: { showTabs: false }
  },
  {
    path: '/gameCircle',
    name: 'GameCircle',
    component: GameCircle,
    meta: { showTabs: false }
  },
  {
    path: '/selectedMaster',
    name: 'SelectedMaster',
    component: SelectedMaster,
    meta: { showTabs: false }
  },
  {
    path: '/inviteFriends',
    name: 'InviteFriends',
    component: InviteFriends,
    meta: { showTabs: false, requiresAuth: true }
  },
  {
    path: '/recharge',
    name: 'Recharge',
    component: Recharge,
    meta: { showTabs: false, requiresAuth: true }
  },
  {
    path: '/signCard',
    name: 'SignCard',
    component: SignCard,
    meta: { showTabs: false, requiresAuth: true }
  },
  {
    path: '/balance',
    name: 'Balance',
    component: Balance,
    meta: { showTabs: false, requiresAuth: true }
  },
  {
    path: '/inviteRecord',
    name: 'InviteRecord',
    component: InviteRecord,
    meta: { showTabs: false, requiresAuth: true }
  },
  {
    path: '/collectionRecord',
    name: 'CollectionRecord',
    component: CollectionRecord,
    meta: { showTabs: false, requiresAuth: true }
  },
  {
    path: '/rechargeRecord',
    name: 'RechargeRecord',
    component: RechargeRecord,
    meta: { showTabs: false, requiresAuth: true }
  },
  {
    path: '/msgCenter',
    name: 'MsgCenter',
    component: MsgCenter,
    meta: { showTabs: false, requiresAuth: true }
  },
  {
    path: '/aboutWM',
    name: 'AboutWM',
    component: AboutWM,
    meta: { showTabs: false }
  },
  {
    path: '/leaveMsg',
    name: 'LeaveMsg',
    component: LeaveMsg,
    meta: { showTabs: false, requiresAuth: true }
  },
  {
    path: '/balanceRecharge',
    name: 'BalanceRecharge',
    component: BalanceRecharge,
    meta: { showTabs: false, requiresAuth: true }
  },
  {
    path: '/coupon',
    name: 'Coupon',
    component: Coupon,
    meta: { showTabs: false, requiresAuth: true }
  },
  {
    path: '/rechargeSearch',
    name: 'RechargeSearch',
    component: RechargeSearch,
    meta: { showTabs: false, requiresAuth: true }
  },
  {
    path: '/homeSearch',
    name: 'HomeSearch',
    component: HomeSearch,
    meta: { showTabs: false }
  },
  {
    path: '/payResult',
    name: 'PayResult',
    component: PayResult,
    meta: { showTabs: false }
  },
  {
    path: '/youLike',
    name: 'YouLike',
    component: YouLike,
    meta: { showTabs: false, requiresAuth: true }
  },
  {
    path: '/accountTrade',
    name: 'AccountTrade',
    component: AccountTrade,
    meta: { showTabs: false, requiresAuth: true }
  },
  {
    path: '/goodsDetail',
    name: 'GoodsDetail',
    component: GoodsDetail,
    meta: { showTabs: false, requiresAuth: true }
  },
  {
    path: '/couponUse',
    name: 'CouponUse',
    component: CouponUse,
    meta: { showTabs: false, requiresAuth: true }
  },
  {
    path: '/problem',
    name: 'Problem',
    component: Problem,
    meta: { showTabs: false }
  },
  {
    path: '/privacyAgreement',
    name: 'PrivacyAgreement',
    component: PrivacyAgreement,
    meta: { showTabs: false }
  },
  {
    path: '/serviceAgreement',
    name: 'ServiceAgreement',
    component: ServiceAgreement,
    meta: { showTabs: false }
  },
  {
    path: '/baseSetting',
    name: 'BaseSetting',
    component: BaseSetting,
    meta: { showTabs: false, requiresAuth: true }
  },
  {
    path: '/tradingNotice',
    name: 'TradingNotice',
    component: TradingNotice,
    meta: { showTabs: false, requiresAuth: true }
  },
  {
    path: '/tradeRecord',
    name: 'TradeRecord',
    component: TradeRecord,
    meta: { showTabs: false, requiresAuth: true }
  },
  {
    path: '/cellAccount',
    name: 'CellAccount',
    component: CellAccount,
    meta: { showTabs: false, requiresAuth: true }
  },
  {
    path: '/accountChose',
    name: 'AccountChose',
    component: AccountChose,
    meta: { showTabs: false, requiresAuth: true }
  },
  {
    path: '/gamePoints',
    name: 'GamePoints',
    component: GamePoints,
    meta: { showTabs: false, requiresAuth: true }
  },
  {
    path: '/myCollect',
    name: 'MyCollect',
    component: MyCollect,
    meta: { showTabs: false, requiresAuth: true }
  },
  {
    path: '/welfareCollection',
    name: 'WelfareCollection',
    component: WelfareCollection,
    meta: { showTabs: false }
  },
  {
    path: '/welfareDetail',
    name: 'WelfareDetail',
    component: WelfareDetail,
    meta: { showTabs: false }
  },
  {
    path: '/allGame',
    name: 'AllGame',
    component: AllGame,
    meta: { showTabs: false }
  },
  
  
  
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = !!localStorage.getItem('uuid'); // 你可以根据实际情况修改这个检查逻辑
  if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn) {
    next({ name: 'Login' });
  } else {
    next();
  }
});


export default router



// WEBPACK FOOTER //
// ./src/router/index.js